import { Nullable } from '_/types/common.types';

const guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const checkIfStringGuid = (value?: Nullable<string>): boolean => !!value && guidPattern.test(value);

export default checkIfStringGuid;
